import styled from "styled-components";


export const VideoWrapper = styled.div`
  background-color: #1e1e1e;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #e0e0e0;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  max-width: 100%;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  width: 100%;
  height: 100%!important;
`;

export const VideoIcon = styled.div`
  font-size: 20px;
  color: #aaa;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VideoInfo = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const VideoTitle = styled.div`
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const VideoMeta = styled.div`
  font-size: 12px;
  color: #888;
  margin-top: 2px;
`;

export const VideoProgress = styled.div`
  font-size: 12px;
  border: 1px solid #555;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
`;

